import SvgIcAudit from '../assets/svg/ic-audit.svg';
import SvgIcCheckSquare from '../assets/svg/ic-check-square-o.svg';
import SvgIcPlus from '../assets/svg/ic-plus.svg';
import SvgIcSendMessageo from '../assets/svg/ic-send-message-o.svg';
import SvgIcCaigou from '../assets/svg/caigou.svg';
import SvgIcBaoxiao from '../assets/svg/baoxiao.svg';
import SvgIcFukuan from '../assets/svg/fukuan.svg';
import SvgIcYusuan from '../assets/svg/yusuanbiangeng.svg';
import SvgIcYunduan from '../assets/svg/yunduan.svg';
import SvgIcAll from '../assets/svg/ic-all-o.svg';
import SvgIcBackbtn from '../assets/svg/ic-left-circle-o.svg';
import SvgIcFile from '../assets/svg/ic-file-o.svg';
import SvgIcEdit from '../assets/svg/ic-edit-o.svg';
import SvgIcCopy from '../assets/svg/ic-copy-o.svg';
import SvgIcEnter from '../assets/svg/ic-enter.svg';
import SvgIcClose from '../assets/svg/ic-close.svg';
import SvgIcNotifications from '../assets/svg/ic-notifications-2.svg';
import SvgIcGuzi from '../assets/svg/ic-guzi.svg';
import CommentAndCopy from "./CommentAndCopy"

const comps = {
  SvgIcAudit,
  SvgIcCheckSquare,
  SvgIcPlus,
  SvgIcSendMessageo,
  SvgIcCaigou,
  SvgIcBaoxiao,
  SvgIcFukuan,
  SvgIcYusuan,
  SvgIcYunduan,
  SvgIcAll,
  SvgIcBackbtn,
  SvgIcFile,
  SvgIcEdit,
  SvgIcCopy,
  SvgIcEnter,
  SvgIcClose,
  SvgIcNotifications,
  SvgIcGuzi,
  CommentAndCopy
  // BudgetImportModal,
};

export function install(Vue) {
  Object.keys(comps).forEach(key => {
    Vue.component(key, comps[key]);
  });
}